import React from "react";
import PropTypes from "prop-types";
import { inlineElements, generateStyle, setOverLay, l } from "../../functions";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import state from "../../state";
import Icon from "../../components/Icons";

import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import isEqual from "lodash/isEqual";

function mapStateToProps(state) {
  return {
    settings: state.rootReducer?.appearanceSettings || {},
  };
}

const useStyles = makeStyles((theme) => ({
  variations: (props) => ({
    backgroundColor: props.variationsBgColor,
    color: props.variationsColor,
    "&:hover": {
      backgroundColor: props.variationsBgColorHover,
      color: props.variationsColorHover,
      boxShadow: props.variationsBgColorHover + " 0px 0px 2px",
    },
  }),
}));

function InitAttributes({ props }) {
  let { payload } = props;

  if (payload === null) payload = props.options.payload;

  const {
    currentDesign,
    variationsLabelColor,
    variationsBgColor,
    variationsColor,
    variationsBgColorHover,
    variationsColorHover,
  } = payload.datas || { currentDesign: 1 };

  const classes = useStyles({
    variationsBgColor: variationsBgColor,
    variationsColor: variationsColor,
    variationsBgColorHover: variationsBgColorHover,
    variationsColorHover: variationsColorHover,
  });

  const cssSettings = generateStyle(payload, "container");
  const cssSettingsText = generateStyle(payload, "text", "body");

  return (
    <Container fluid={payload.fullContainer} style={cssSettings}>
      {setOverLay(payload)}
      <Row>
        <Col xs={12} className="fullcol" style={cssSettingsText}>
          <div
            className={`product-block-info layout${currentDesign} align-${payload.settings.alignment}`}
          >
            <div className="productcolorbox">
              <span style={{ color: variationsLabelColor }}>Color</span>
              <ul className="color_variation">
                <li className="blue active">
                  <a href="#" title="Title!"></a>
                </li>
                <li className="green">
                  <a href="#" title="Title!"></a>
                </li>
                <li className="lightgreen">
                  <a href="#" title="Title!"></a>
                </li>
              </ul>
            </div>
            <div className="size_box">
              <label style={{ color: variationsLabelColor }}>Size</label>
              <div className="selectbox">
                {((!currentDesign ||
                  (currentDesign &&
                    (currentDesign === 1 || currentDesign === 2))) && (
                  <ul className="sizelist">
                    <li>
                      <a href="#" className={classes.variations} title="S">
                        S
                      </a>
                    </li>
                    <li>
                      <a href="#" className={classes.variations} title="M">
                        M
                      </a>
                    </li>
                    <li>
                      <a href="#" className={classes.variations} title="L">
                        L
                      </a>
                    </li>
                    <li>
                      <a href="#" className={classes.variations} title="XL">
                        XL
                      </a>
                    </li>
                    <li>
                      <a href="#" className={classes.variations} title="2XL">
                        2XL
                      </a>
                    </li>
                  </ul>
                )) || (
                  <ul className="sizelist">
                    <li>
                      <label className="radios_select">
                        <input
                          type="radio"
                          defaultChecked="checked"
                          name="radio"
                        />
                        S <span className="checkmark"></span>
                      </label>
                    </li>
                    <li>
                      <label className="radios_select">
                        <input type="radio" name="radio" />M
                        <span className="checkmark"></span>
                      </label>
                    </li>
                    <li>
                      <label className="radios_select">
                        <input type="radio" name="radio" />L
                        <span className="checkmark"></span>
                      </label>
                    </li>
                    <li>
                      <label className="radios_select">
                        <input type="radio" name="radio" />
                        XL<span className="checkmark"></span>
                      </label>
                    </li>
                    <li>
                      <label className="radios_select">
                        {" "}
                        <input type="radio" name="radio" />
                        2XL<span className="checkmark"></span>
                      </label>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
class ProductAttributes extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className="added">{l("Added")}</span>) || (
              <span className="required">{l("Required")}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return (
        <div>
          <InitAttributes props={this.props} />
        </div>
      );
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        <InitAttributes props={this.props} />
      </Draggable>
    );
  }
}

ProductAttributes.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductAttributes);
